import Category from './category'
import CategoryItem from './categoryItem'

export default class {
  constructor (model) {
    this.id = model.id
    this.name = model.name
    this.subCategories = []
    this.items = []
    const self = this
    if (model.subCategories) {
      model.subCategories.forEach((categ) => {
        self.subCategories.push(new Category(categ))
      })
    } else {
      model.subCategories = null
    }
    if (model.items) {
      model.items.forEach((item) => {
        self.items.push(new CategoryItem(item))
      })
    } else {
      this.items = null
    }
  }

  get completedRatio () {
    if (this.subCategories === null) {
      return 0
    }
    var nbQuestions = 0
    var nbValidated = 0

    this.subCategories.forEach((categ) => {
      categ.items.forEach((item) => {
        nbQuestions++
        nbValidated += (item.answer !== null && item.answer === true) ? 1 : 0
      })
    })

    return parseInt(nbValidated * 100 / nbQuestions)
  }
}
